import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from './guards/auth-guard.service';
import { FeatureGuardService } from './guards/feature-guard.service';
import { FeatureNames } from './shared/models/feature-names.enum';

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'account/login'
    },
    {
        path: 'account',
        loadChildren: () =>
            import('./account/account.module').then((m) => m.AccountModule),
    },
    {
        path: 'investments',
        loadChildren: () =>
            import('./investments/investments.module').then((m) => m.InvestmentsModule),
            canActivate: [FeatureGuardService],
            data: {featureRequired: FeatureNames.INVESTMENTS}
    },
    {
        path: 'privacy',
        loadChildren: () =>
            import('./privacy/privacy.module').then((m) => m.PrivacyModule),
    },
    {
        path: 'faq',
        loadChildren: () =>
            import('./faq/faq.module').then((m) => m.FaqModule),
    },
    {
        path: 'token-home',
        loadChildren: () =>
            import('./token-home/token-home.module').then((m) => m.HomeModule),
        canActivate: [AuthGuardService],
    },
    {
        path: 'navigation',
        loadChildren: () =>
            import('./internal-navigation/internal-navigation.module').then((m) => m.InternalNavigationModule),
        canActivate: [AuthGuardService],
    },
    {
        path: 'digital-banking',
        loadChildren: () =>
            import('./digital-banking/digital-banking.module').then((m) => m.DigitalBankingModule),
        canActivate: [FeatureGuardService],
        data: { featureRequired: FeatureNames.DIGITAL_BANKING }
    },
    {
        path: 'home',
        loadChildren: () =>
            import('./home/home.module').then((m) => m.HomeModule)
    },
    {
        path: '2fa',
        loadChildren: () =>
            import('./2fa/2fa.module').then((m) => m.MFAModule)
    },
    {
        path: 'exchange',
        loadChildren: () =>
            import('./exchange/exchange.module').then((m) => m.ExchangeModule),
        canActivate: [FeatureGuardService],
        data: { featureRequired: FeatureNames.EXCHANGE }
    },
    {
        path: 'otc',
        loadChildren: () =>
            import('./otc/otc.module').then((m) => m.OtcModule),
        canActivate: [AuthGuardService],
    },
    {
        path: 'marketplace',
        loadChildren: () =>
            import('./marketplace/marketplace.module').then((m) => m.MarketplaceModule),
        data: { featureRequired: FeatureNames.MIDAS_MARKETPLACE }
    },
    {
        path: 'complete-your-registration',
        loadChildren: () =>
            import('./complete-your-registration/complete-your-registration.module').then((m) => m.CompleteYourRegistrationModule),
        canActivate: [AuthGuardService],
    },
    {
        path: 'tokenization',
        loadChildren: () =>
            import('./tokenization/tokenization.module').then((m) => m.TokenizationModule),
        data: { featureRequired: FeatureNames.MIDAS_MARKETPLACE }
    },
    {
        path: 'chat',
        loadChildren: () =>
            import('./chat/chat.module').then((m) => m.ChatModule),
        // canActivate: [AuthGuardService], // TODO
        // data: {featureRequired: FeatureNames.CHAT}
    },
    {
        path: 'profile',
        loadChildren: () =>
            import('./profile/profile.module').then((m) => m.ProfileModule),
        canActivate: [AuthGuardService],
    },
    {
        path: 'contracts',
        loadChildren: () =>
            import('./contracts/contracts.module').then((m) => m.ContractsModule),
        canActivate: [AuthGuardService],
    },
    {
        path: 'applications',
        loadChildren: () =>
            import('./apis/applications/applications.module').then((m) => m.ApplicationModule),
            canActivate: [AuthGuardService],
            data: { featureRequired: FeatureNames.USER_API_MANAGEMENT }
    },
    {
        path: 'swagger',
        loadChildren: () =>
            import('./apis/api/api.module').then((m) => m.ApiModule),
            canActivate: [AuthGuardService],
            data: { featureRequired: FeatureNames.USER_API_MANAGEMENT }
    },
    {
        path: 'notifications',
        loadChildren: () =>
            import('./notifications/notifications.module').then((m) => m.NotificationsModule),
        canActivate: [AuthGuardService],
    },
    {
        path: 'devices-management',
        loadChildren: () =>
            import('./devices-management/devices-management.module').then((m) => m.DevicesManagementModule),
        canActivate: [AuthGuardService],
    },
    {
        path: 'limits',
        loadChildren: () =>
            import('./limits/limits.module').then((m) => m.LimitsModule),
        canActivate: [AuthGuardService],
    },
    {
        path: 'checkout',
        loadChildren: () =>
            import('./checkout/checkout.module').then((m) => m.CheckoutModule),
        canActivate: [AuthGuardService],
    },
    {
        path: 'swap',
        loadChildren: () =>
            import('./swap/swap.module').then((m) => m.SwapModule),
        canActivate: [AuthGuardService],
        data: { featureRequired: FeatureNames.SWAP }
    },
    {
        path: 'bridge',
        loadChildren: () =>
            import('./bridge/bridge.module').then((m) => m.BridgeModule),
        canActivate: [AuthGuardService],
    },
    {
        path: 'external-deposit',
        loadChildren: () =>
            import('./external-deposit/external-deposit.module').then((m) => m.ExternalDepositModule)
    },
    {
        path: 'antifraud-approval',
        loadChildren: () =>
            import('./antifraud-approval/antifraud-approval.module').then((m) => m.AntifraudApprovalModule)
    },
    {
        path: '**',
        redirectTo: 'home'
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
